import round from 'lodash/round';

export const roundToTwoDecimals = (value) => round(Number(value), 2);
